const { exchangeDateError } = require('./exchangeEnglish');

// Même mise en forme pour les saisies étudiantes et administratives des échanges.
function normalizeExchangeValue(question, raw) {
  if (typeof raw !== 'string') return raw;
  if (question.placeholder === 0) {
    let value = raw.toLowerCase().replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ' \-^¨]/g, '');
    if (value.startsWith('-') || value.startsWith("'")) value = value.slice(1);
    value = value.charAt(0).toLocaleUpperCase('fr') + value.slice(1);
    return value.replace(/([-'\s])([a-zA-ZÀ-ÖØ-öø-ÿ])/g, (match, separator, letter) => separator + letter.toLocaleUpperCase('fr'));
  }
  if (question.placeholder === 1) return raw.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ' \-^¨]/g, '').toUpperCase();
  if (question.placeholder === 2) {
    let value = raw.replace(/[^\d+]/g, '');
    if (value.startsWith('0')) return value.replace(/^0(\d{9}).*/, '0$1').replace(/(\d{2})(?=\d)/g, '$1 ').trim();
    if (value.startsWith('+')) return '+' + value.slice(1).replace(/\D/g, '');
    return '';
  }
  return raw;
}

function exchangeFieldError(question, raw, lang = 'fr') {
  const message = (fr, en) => lang === 'en' ? en : fr;
  if (raw === '' || raw === undefined || raw === null) return ''; // Les brouillons incomplets restent possibles.
  if (!['string', 'number', 'boolean'].includes(typeof raw) || (typeof raw === 'number' && !Number.isFinite(raw))) return message('Valeur invalide.', 'Invalid value.');
  if (['text', 'textarea', 'email', 'date', 'tel', 'search', 'select'].includes(question.type) && typeof raw !== 'string') return message('Valeur textuelle attendue.', 'A text value is required.');
  const value = String(raw);
  if (!value.trim()) return message('Renseignez une valeur ou laissez le champ vide.', 'Enter a value or leave the field empty.');
  const limit = Number(question.maxLength || question.maxlength) || 20000;
  if (value.length > limit) return message(`Ce champ est limité à ${limit} caractères.`, `This field is limited to ${limit} characters.`);
  if (question.type === 'email' || question.placeholder === 10) {
    if (!/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value)) return message('Adresse e-mail invalide.', 'Enter a valid email address.');
  }
  if (question.type === 'date') {
    const error = exchangeDateError(value);
    if (error) {
      if (lang === 'en') return error;
      return error.includes('future') ? 'La date de naissance ne peut pas être dans le futur.' : 'Saisissez une date valide au format AAAA-MM-JJ.';
    }
  }
  if (question.placeholder === 0 || question.placeholder === 1) {
    if (!/^[a-zA-ZÀ-ÖØ-öø-ÿ' \-^¨]+$/.test(value) || normalizeExchangeValue(question, value) !== value) {
      return question.placeholder === 0
        ? message('Utilisez des lettres, espaces, tirets ou apostrophes, avec une majuscule au début de chaque prénom.', 'Use letters, spaces, hyphens or apostrophes, with a capital letter at the start of each name.')
        : message('Utilisez des lettres majuscules, espaces, tirets ou apostrophes uniquement.', 'Use uppercase letters, spaces, hyphens or apostrophes only.');
    }
  }
  if (question.placeholder === 2 && !/^(?:0[\d ]*|\+\d+)$/.test(value)) return message('Utilisez un numéro commençant par 0 ou +, sans lettres.', 'Use a phone number starting with 0 or +, without letters.');
  if (question.type === 'select' && Array.isArray(question.Options) && !question.Options.some(option => String(option.value) === value)) return message('Sélectionnez une valeur proposée dans la liste.', 'Select a value from the list.');
  if (question.pattern) {
    try {
      if (!new RegExp(`^(?:${question.pattern})$`, 'u').test(value)) return message('La valeur ne respecte pas le format attendu pour ce champ.', 'The value does not match the required format for this field.');
    } catch { return message('Le format de ce champ est mal configuré.', 'The format for this field is not configured correctly.'); }
  }
  return '';
}

module.exports = { normalizeExchangeValue, exchangeFieldError };
